export enum OtherServicesForm {
    OtherServicesTelecom = 'otherServicesTelecom',
    RequestWithoutMover = 'requestWithoutMover',
    AdditionalNotes = 'additionalNotes',
    RealEstateAgentConsent = 'realEstateAgentConsent',
}
